<template>
  <div class="ic-tab" :class="{ inline, outlined }">
    <template v-for="item in items">
      <div
        class="ic-tab-item"
        :class="{ active: item.key === activeKey }"
        :key="item.key"
        v-if="item.key && item.text"
        @click.stop="handleClick(item)"
      >
        {{ item.text }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: null,
    },
    active: {
      type: String,
      default: null,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
  },
  created() {
    if (this.items && this.items.length > 0 && this.items[0].key) {
      this.activeKey = this.active ? this.active : this.items[0].key
      this.$emit('input', this.activeKey)
    }
  },
  mounted() {
    if (this.items && this.items.length > 0 && this.items[0].key) {
      this.activeKey = this.active ? this.active : this.items[0].key
      this.$emit('input', this.activeKey)
    }
  },
  data() {
    return {
      activeKey: '',
    }
  },
  methods: {
    handleClick(item) {
      this.activeKey = item.key
      this.$emit('change', item.key)
      this.$emit('input', this.activeKey)
    },
  },
}
</script>

<style lang="scss" scoped>
@import './IcTab.scss';
</style>
